import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/macro';
import { connect } from 'react-redux';

import ThreeEssentailsButton from '../three-essentails-button/three-essentails-button';
import ConsoleModalContext from '../../containers/console/context/console-modal-context';
import OrganiseClassGroupsModal from './components/organise-class-groups-modal/organise-class-groups-modal';
import { PRODUCT_IDS } from '../../helpers/enums';
import Toast from '../toast/toast';
import successIcon from '../../assets/images/icons/ico_success.svg';

const OneRosterOrganiseClassGroups = (
    { createMultiYearGroups, classroomId, updateCurrentClassId,
        hasContentLoaded, resetMultiYearGroupFetch, isMultiLevelGroupsCreated, createdMultiLevelGroupsCount }) => {
    const [showToast, setShowToast] = useState(false);
    const { showConsoleModal, setShowConsoleModal, setConsoleModalContent } = useContext(ConsoleModalContext);
    const closeOrganiseClassGroupsModal = () => {
        setShowConsoleModal(false);
    };

    const clickHandler = async () => {
        await createMultiYearGroups({ classId: classroomId });
        await updateCurrentClassId({ productId: PRODUCT_IDS.Mathletics, classId: classroomId });
    };

    useEffect(() => {
        if (isMultiLevelGroupsCreated) {
            setShowToast(true);
        }
    }, [isMultiLevelGroupsCreated]);

    useEffect(() => {
        if (isMultiLevelGroupsCreated) {
            closeOrganiseClassGroupsModal(true);
        }
    }, [isMultiLevelGroupsCreated]);

    const showOrganiseClassGroupsModal = () => {
        setShowConsoleModal(!showConsoleModal);
        resetMultiYearGroupFetch();
        setConsoleModalContent((
            <OrganiseClassGroupsModal
                classroomId={classroomId}
                clickHandler={clickHandler}
                title={<Trans id="One Roster - Organise Class Groups - Modal Header" />}
                description={<Trans id="One Roster - Organise Class Groups - Modal Body" />}
                closeHandler={closeOrganiseClassGroupsModal}
                hasContentLoaded={hasContentLoaded}
                isMultiLevelGroupsCreated={isMultiLevelGroupsCreated} />
        ));
    };

    return (
        <React.Fragment>
            <Toast
                icon={successIcon}
                hideIcon
                variant={'success'}
                showToast={showToast}
                message={
                    <Trans
                        id="One Roster - Toaster - Students have been rearranged - {numberOfGroups}"
                        values={{ numberOfGroups: createdMultiLevelGroupsCount }} />
                }
                onClose={() => {
                    setShowToast(false);
                }
                }
            />
            <div className="groups__button-container">
                <ThreeEssentailsButton
                    clickHandler={showOrganiseClassGroupsModal}
                    title={<Trans id="One Roster - Organise class groups" />}
                    show3EIcon={false}
                    buttonClassName={'edit_group_name'}
                    showArrow={false}
                />
            </div>
        </React.Fragment>
    );
};

OneRosterOrganiseClassGroups.propTypes = {
    createMultiYearGroups: PropTypes.func.isRequired,
    classroomId: PropTypes.number.isRequired,
    updateCurrentClassId: PropTypes.func.isRequired,
    resetMultiYearGroupFetch: PropTypes.func.isRequired,
    hasContentLoaded: PropTypes.bool,
    createdMultiLevelGroupsCount: PropTypes.number,
    isMultiLevelGroupsCreated: PropTypes.bool
};

function mapStateToProps(state) {
    const {
        createdMultiLevelGroupsCount,
        isMultiLevelGroupsCreated
    } = state.consoleReducer;

    return {
        createdMultiLevelGroupsCount,
        isMultiLevelGroupsCreated
    };
}

export default connect(mapStateToProps)(OneRosterOrganiseClassGroups);



// WEBPACK FOOTER //
// ./components/one-roster-organise-class-groups/one-roster-organise-class-groups.js